import CampaignPicturesApp from 'campaign/components/campaignDocuments/CampaignPicturesApp'
import React from 'react'

const PiezometryCampaignPicturesApp = () => (
    <CampaignPicturesApp stationType='piezometry' />
)

export default PiezometryCampaignPicturesApp
